import React from 'react';
import InsightSetDetailsForm from './InsightSetDetailsForm';

class InsightSetDetails extends React.Component {
  static displayName = 'InsightSetDetails';

  constructor(props) {
    super(props);
    this.state = {
      isSaving: false,
      errorMsg: undefined,
      successMsg: undefined
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    this.screenReaderContent.focus();
  }

  componentWillUnmount() {
    // clear timeout to prevent setState on unmounted component
    clearTimeout(this.timeoutId);
  }

  handleSubmit = values => {
    this.setState({ isSaving: true, errorMsg: undefined });
    if (values.id) {
      this.props
        .updateInsightSet(values)
        .then(
          response => this.success(response, false),
          error => this.failure(error)
        );
    } else {
      this.props
        .addInsightSet(values)
        .then(
          response => this.success(response, true),
          error => this.failure(error)
        );
    }
  };

  success = (response, redirect = false) => {
    this.setState({
      isSaving: false,
      errorMsg: undefined,
      successMsg: 'Success!'
    });
    this.timeoutId = setTimeout(
      () => this.setState({ successMsg: undefined }),
      3000
    );

    if (redirect) {
      const newId = response.data.id;
      this.props.router.push(`/insight-sets/${newId}`);
    }
  };

  failure = error => {
    this.setState({ isSaving: false, errorMsg: error.data.message });
  };

  render() {
    return (
      <div>
        <h3
          className="screen-reader-only"
          tabIndex="-1"
          ref={i => (this.screenReaderContent = i)}
        >
          Showing details for insight set {this.props.currentInsightSet.name}
        </h3>

        <InsightSetDetailsForm
          {...this.props}
          onSubmit={this.handleSubmit}
          initialValues={this.props.currentInsightSet}
          enableReinitialize={true}
          isSaving={this.state.isSaving}
          errorMsg={this.state.errorMsg}
          successMsg={this.state.successMsg}
        />
      </div>
    );
  }
}

export default InsightSetDetails;



// WEBPACK FOOTER //
// ./src/containers/insightset/InsightSetDetails.js